import React, { useEffect, useState } from 'react'
import './CreateEditBulkNotification.scss'
import { Image_Url } from '../../constants/imageUrl/ImageUrl';
import Cookies from "js-cookie";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { HTTP_STATUS } from '../../constants/httpstatus/HttpsStatus';
import { NotificationManager } from 'react-notifications';
import {
    createNotificationScheduleBulkAction,
    getBulkNotificationDetailsAction,
    getRedirectionPageAction,
    updateBulkNotificationAction
} from '../../actions/NotificationAction';
import { use } from 'react';

const CreateBulkNotification = () => {

    const { i18n, t } = useTranslation();
    const language = Cookies.get("language");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const isEditMode = Boolean(id);
    const [fileName, setFileName] = useState('');
    const [templateType, setTemplateType] = useState('Mobile No.');
    const [isLoading, setIsLoading] = useState(false);
    const { redirectionPageList } = useSelector((state) => state.getRedirectionPageReducer);
    const { bulkNotificationDetails } = useSelector((state) => state.bulkNotificationDetailsReducer);

    const [formData, setFormData] = useState({
        title: '',
        body: '',
        starting_date: '',
        starting_time: '',
        redirection_page: '',
        attachment: ''
    });

    useEffect(() => {
        handleChangeLanguage(language);
        dispatch(getRedirectionPageAction());
    }, []);
    useEffect(() => {
        if (isEditMode) {
            dispatch(getBulkNotificationDetailsAction(id));
        }
    }, [isEditMode])
    useEffect(() => {
        if (isEditMode && bulkNotificationDetails?.results?.length > 0) {
            const data = bulkNotificationDetails?.results[0];
            setFormData({
                title: data?.title || '',
                body: data?.body || '',
                starting_date: data?.starting_date || '',
                starting_time: data?.starting_time || '',
                redirection_page: data?.redirection_page?.id || '',
                attachment: null
            });
            setFileName(data?.file_name || '');
        }
    }, [bulkNotificationDetails, isEditMode]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            setFileName(file.name);
            setFormData(prev => ({ ...prev, attachment: file }));
        }
    };

    const handleDownloadTemplate = () => {
        let downloadUrl = '';

        if (templateType === 'Mobile No.') {
            downloadUrl = `${process.env.PUBLIC_URL}/templates/NotificationTemplate_MobileNumber.xlsx`;
        } else if (templateType === 'User Id') {
            downloadUrl = `${process.env.PUBLIC_URL}/templates/NotificationTemplate_UserId.xlsx`;
        }

        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = downloadUrl.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const buildFormData = () => {
        const formDataToSend = new FormData();
        for (const key in formData) {
            if (formData[key]) {
                if (key === "attachment" && !(formData[key] instanceof File)) continue;
                formDataToSend.append(key, formData[key]);
            }
        }
        return formDataToSend;
    };
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const selectedDateTime = new Date(`${formData.starting_date}T${formData.starting_time}`);
        const now = new Date();
        if (selectedDateTime < now) {
            NotificationManager.error(t("notification.timeValidation"));
            setIsLoading(false);
            return;
        }
        const formDataToSend = buildFormData();

        let response;
        if (isEditMode) {
            response = await dispatch(updateBulkNotificationAction(id, formDataToSend));
        } else {
            response = await dispatch(createNotificationScheduleBulkAction(formDataToSend));
        }
        const { status, message } = response;
        if (status === HTTP_STATUS.CREATED || status === HTTP_STATUS.SUCCESS) {
            NotificationManager.success(message);
            navigate('/notification_list');

        } else {
            NotificationManager.error(message);
        }
        setIsLoading(false);
    };

    const handleOnClose = () => {
        navigate('/notification_list')
    }

    const handleChangeLanguage = (language) => {
        i18n.changeLanguage(language);
    };

    const isFormValid = () => {
        return (
            formData.title?.trim() &&
            formData.body?.trim() &&
            formData.starting_date &&
            formData.starting_time &&
            formData.redirection_page &&
            (isEditMode || formData.attachment)
        );
    };


    return (
        <div className='create-notification-excel'>
            <div className='create-notification-excel-content'>
                <div className='create-notification-excel-section'>
                    <div className="header-navigation">
                        <p className="create-notification-excel-text">TVS &gt; {isEditMode ? t('notification.editBulkNotification') : t('notification.createBulkNotification')}</p>
                    </div>
                    <div className='create-notification-excel-main'>
                        <h3 className='create-notification-heading'>
                            {isEditMode ? t('notification.editBulkNotification') : t('notification.createBulkNotification')}
                        </h3>
                        <div className='create-notification-excel-form'>
                            <form className='notification-excel-form'>
                                <div className='download-template'>
                                    <div className="form-group-excel">
                                        <label className='notification-excel-label required'>{t('common.downloadTemplate')}</label>
                                        <select className='select-excel-template-criteria'
                                            value={templateType}
                                            onChange={(e) => setTemplateType(e.target.value)}
                                        >
                                            <option>{t('common.mobileNumber')}</option>
                                            <option>{t('common.userid')}</option>
                                        </select>
                                    </div>
                                    <div className='download-excel-template-button'>
                                        <button className="dexcel partner-excel-download"
                                            onClick={handleDownloadTemplate}
                                        >
                                            <img src={Image_Url.DEXCEL} className="downloads_imgdexcel" />
                                            {t('common.downloadTemplate')}
                                        </button>
                                    </div>
                                </div>

                                <div className='download-template'>
                                    <div className="form-group-excel">
                                        <label className='notification-excel-label required'>{t('common.uploadExcel')}</label>
                                        <input
                                            type='text'
                                            className='select-excel-template-criteria'
                                            value={fileName}
                                            placeholder={t('common.noFileChoosen')}
                                            readOnly
                                        />
                                    </div>
                                    <div className='choose-file-button'>
                                        <input
                                            type='file'
                                            accept=".xlsx, .xls"
                                            onChange={(e) => handleFileChange(e)}
                                            style={{ display: 'none' }}
                                            id="file-upload"
                                        />
                                        <label htmlFor="file-upload" className="custom-file-upload">
                                            {t('common.chooseFile')}
                                        </label>
                                    </div>
                                </div>

                                <div className='download-template'>
                                    <div className="form-group-excel">
                                        <label className='notification-excel-label required'>{t('notification.heading')}</label>
                                        <input
                                            className='select-excel-template-criteria'
                                            type="text"
                                            placeholder={t('notification.enterHeading')}
                                            value={formData.title}
                                            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group-excel">
                                        <label className='notification-excel-label required'>{t('notification.redirectionPage')}</label>
                                        <select
                                            className='select-excel-template-criteria'
                                            value={formData.redirection_page}
                                            onChange={(e) => setFormData({ ...formData, redirection_page: Number(e.target.value) })}
                                        >
                                            <option value="">{t('notification.selectRedirectionPage')}</option>

                                            {redirectionPageList?.map((page) => (
                                                <option key={page?.id} value={page?.id}>
                                                    {page?.page}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group-excel-description">
                                    <label className='notification-excel-description-label required'>{t('common.description')}</label>
                                    <textarea
                                        className='notification-excel-description-textarea'
                                        placeholder={t('common.enterDescription')}
                                        value={formData.body}
                                        onChange={(e) => setFormData({ ...formData, body: e.target.value })}
                                    />
                                </div>

                                <div className='download-template'>
                                    <div className="form-group-excel">
                                        <label className='notification-excel-label required'>{t('notification.sendOnDate')}</label>
                                        <input
                                            className='select-excel-template-criteria'
                                            type="date"
                                            min={new Date().toISOString().split("T")[0]}
                                            value={formData.starting_date}
                                            onChange={(e) => setFormData({ ...formData, starting_date: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group-excel">
                                        <label className='notification-excel-label required'>{t('notification.sendOnTime')}</label>
                                        <input
                                            className='select-excel-template-criteria'
                                            type="time"
                                            value={formData.starting_time}
                                            onChange={(e) => setFormData({ ...formData, starting_time: e.target.value })}
                                        />
                                    </div>
                                </div>

                                <div className="button-group">
                                    <button className="close-btn" onClick={handleOnClose}>{t('common.close')}</button>
                                    <button className="send-btn" onClick={handleSubmit} disabled={!isFormValid() || isLoading}>
                                        {isLoading ? <span className="loader-btn"></span> : (isEditMode ? t('common.update') : t('common.send'))}
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default CreateBulkNotification